import { setupMAA } from "MAA.boostrap";

import "./localization/i18n";

setupMAA();
